import { FaGift } from 'react-icons/fa';
import Image from 'next/image';
import { currencyFormat } from '@/utils';
import { useRouter } from 'next/router';

const getProductImage = (name: string) => {
  switch (name.toLowerCase()) {
    case 'botellas':
      return (
        <Image src="/wine-bottlewine.svg" alt="bottle" width={40} height={40} />
      );
    case 'cocteles':
      return (
        <Image
          src={'/martini-glass.svg'}
          alt="cocktail"
          width={40}
          height={40}
        />
      );
    case 'comidas':
      return <Image src={'/pot-food.svg'} alt="bowl" width={40} height={40} />;
    default:
      return <FaGift />;
  }
};

const ProductCard = ({ product }) => {
  const router = useRouter();
  const language = router.locale as SupportedLanguages;
  const isSpanish = language === 'es';
  return (
    <div className="flex flex-col items-start justify-between h-40 w-40 border border-[#D0D0D0] p-4 basis-40 shrink-0 rounded-l-xl rounded-br-xl rounded-tr-3xl">
      {getProductImage(product.name)}
      <div className="flex flex-col items-start w-full">
        <h3 className="text-lg font-bold">{product.name}</h3>
        {isSpanish ? (
          <p className="text-sm">
            Entre {currencyFormat(product.min_price)} y{' '}
            {currencyFormat(product.max_price)}
          </p>
        ) : (
          <p className="text-sm">
            Between {currencyFormat(product.min_price)} and{' '}
            {currencyFormat(product.max_price)}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
